import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext } from '../../../../../AppContext';
import Toolbar from './ServicestatusesTableToolbar';
import ColumnDefinition from './ServicestatusesTableColumnDefinition';
import RowsMapper from './ServicestatusesTableRowsMapper';
import localization from './ServicestatusesTable.local';

export default function ServicestatusesTable({
  servicestatuses,
  onRowClick,
  onAddClick,
  onCategoriesClick,
}) {
  const local = localization[useContext(LocalizationContext)];
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();

  useEffect(() => setColumns(ColumnDefinition(local)), []);
  useEffect(() => setRows(RowsMapper(local, servicestatuses)), [servicestatuses]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
        <DataGrid
          sx={{ height: '100%' }}
          rows={rows}
          columns={columns}
          onRowClick={({ row }) => onRowClick(row.id)}
          components={{ Toolbar }}
          componentsProps={{ toolbar: { local, onAddClick, onCategoriesClick } }}
        />
      )}
    </Paper>
  );
}

ServicestatusesTable.propTypes = {
  servicestatuses: PropTypes.arrayOf(PropTypes.shape({})),
  onRowClick: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  onCategoriesClick: PropTypes.func.isRequired,
};

ServicestatusesTable.defaultProps = {
  servicestatuses: undefined,
};
